import './address'
import './card_coupon'
import './time'
import './price'
import './film'
import './text'
import './center'
// import './coupon'
import './refund'
import './balance'
import './buyer'
import './idCard'
import './count'
import './order'
